//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  data() {
    return {
      message: {
        title: '',
        describe: '',
        describeColor: '#333',
        showButton: '',
      },
      options: {
        buttonName: [],
        buttonColor: [],
        buttonBgcolor: [],
        bgColor: '',
        cb() {},
      },
      visible: false,
    };
  },
  methods: {
    cancle() {
      this.$messagebox['cancle']();
    },
    sure() {
      this.$messagebox['sure']();
    },
  },
};
